import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';

// import { AuthService } from '../../../../../../../../core/auth/auth-service';
// import { UserProfile } from '../../../../../../../../core/dto/user-profile';

import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.page.html',
  styleUrls: ['./showcase.page.scss'],
})
export class ShowcasePage implements OnInit {

  backgroundImage: string;
  userProfile: UserInfoProfile;
  listKeys: [];
  dataRegister: any;
  cdr: any;
  cpfCnpj: any;
  email: any;
  phone: any;
  virtualAdrress: any;
  listObjectCards: { path: any; type: string; cardLabel: string; inputLabel: string }[];

  stepOne: boolean;
  stepTwo: boolean;
  formPortabilityKey: FormGroup;
  param: any;
  wlName: {};

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    protected authService: UserInfoService,
    private translate: UiBsTranslateService
  ) {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');

    this.wlName = {
      wlName: this.layoutConfigService.getConfig('wlTheme.wlName'),
    };

    this.dataRegister = new Date();
  }

  async ngOnInit() {}

  continue() {
    this.navController.navigateRoot(['app/pix/portability']);
  }

  getImageTag(tag: string) {
    let item: any = this.layoutConfigService.getImagesPages(tag);
    return item.path;
  }
}
